module.exports = __webpack_public_path__ + "img/terminal-check.05f72003.png";